<template>
    <!--
    Footer Bar component
    Bar containing actions and a label provided by slot
    -->
    <transition name="bounce-up">
        <footer class="footer-bar" v-if="hasFooterBar">
            <span>{{ $t('layout.footer.info') }}</span>

            <action color="transparent" @click.native="$emit('reset')">
                <small>{{ $t('layout.footer.cancel') }}</small>
            </action>

            <action v-if="$route.name === 'team.edit'" color="orange" @click.native="emitSubmitWithDate">
                {{ $t('layout.footer.saveWithDate') }}
            </action>

            <action color="green" @click.native="$emit('submit')">
                {{ $t('layout.footer.save') }}
            </action>
        </footer>
    </transition>
</template>

<script>
import {mapState} from 'vuex';
import events from '../../events/events';

export default
{
    name: 'FooterBar',

    mounted()
    {
        this.captureSave();
    },

    destroyed()
    {
        this.$store.dispatch('layout/hideFooterBar');
    },

    methods:
        {
            // Add ctrl + s shortcut
            captureSave()
            {
                document.addEventListener('keydown', (e) =>
                {
                    if (this.hasFooterBar && (window.navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey) && e.keyCode === 83)
                    {
                        e.preventDefault()
                        this.$emit('submit')
                    }
                }, false)
            },

            emitSubmitWithDate() {
                events.$emit('submitWithDate')
            },

        },

    computed:
    {
        ...mapState({
            hasFooterBar: ({ layout }) => layout.hasFooterBar,
        })
    },
}
</script>



// WEBPACK FOOTER //
// FooterBar.vue?02656014